import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { UtilsModule } from '@app/modules/utils.module';
import { CasinoImageComponent, CasinoImageUtil } from '@components/casino/casino-image-card';
import { CasinoLobbyComponent } from '@components/casino/casino-lobby.component';
import { SliderComponent } from '@components/casino/slider-component';
import { CasinoGameDialog } from '@components/casino/casinoGame.dialog';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CasinoLoadingDialog } from '@components/casino/casinoLoading.dialog';
import { CasinoHelper } from '@components/casino/casino.helper';
import { CasinoBannerComponent } from '@components/casino/casino-banner.component';
import { CasinoLoadingService } from '@components/casino/casino-loading.service';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
  {
    path: 'lobby/:casinoCategory/:casinoProvider',
    component: CasinoLobbyComponent,
  },
];

@NgModule({
  imports: [LazyLoadImageModule, CommonModule, FormsModule, ReactiveFormsModule, SharedModule, ZXingScannerModule, RouterModule.forChild(routes), UtilsModule, TranslateModule],
  declarations: [CasinoImageComponent, CasinoLobbyComponent, SliderComponent, CasinoGameDialog, CasinoImageUtil, CasinoLoadingDialog, CasinoBannerComponent],
  exports: [CasinoImageComponent, CasinoImageUtil, CasinoLoadingDialog, CasinoBannerComponent],
  providers: [CasinoHelper, ScrollDispatcher, CasinoLoadingService],
})
export class CasinoModule {}
